// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"920":"931c1dac6ee5d663702d","921":"851e4fea30f614157edb"}[chunkId] + ".js";
};